import { FuseLoadable } from '@fuse';
import { authRoles } from 'app/auth';

export default {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/silo-washes', component: FuseLoadable({ loader: () => import('./SiloWashesApp') }) }],
};
